var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor cache-read" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("tables.automationblock.cacheKey"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t("tables.automationblock.readKeyPlaceholder"),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.key,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "key", $$v)
              },
              expression: "clone.key",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "help-text" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("tables.automationblock.readKeyHelp"))),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              _vm._s(
                _vm.$t("tables.automationblock.defaultValueIfMissingTitle")
              )
            ),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t(
                "tables.automationblock.defaultValueIfMissingPlaceholder"
              ),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.defaultValue,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "defaultValue", $$v)
              },
              expression: "clone.defaultValue",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "help-text" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("lightbulb")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("tables.automationblock.defaultValueIfMissingHelp")
                )
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "output-info" }, [
          _c("div", { staticClass: "info-title" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("output")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("tables.automationblock.outputInfo"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "output-attributes" }, [
            _c("div", { staticClass: "attribute-item" }, [
              _c("code", [
                _vm._v(_vm._s(_vm.$t("auto.cacheReadBlockBlockidValue"))),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("tables.automationblock.attrValueOrDefault"))
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "attribute-item" }, [
              _c("code", [
                _vm._v(_vm._s(_vm.$t("auto.cacheReadBlockBlockidFound"))),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("tables.automationblock.attrCacheFound"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "attribute-item" }, [
              _c("code", [
                _vm._v(_vm._s(_vm.$t("auto.cacheReadBlockBlockidSuccess"))),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("tables.automationblock.successBooleanLabel"))
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }